import { Empty } from 'antd';
import styled from 'styled-components';

export const Image = styled.img<{
  width?: string;
  height?: string;
}>`
  width: ${p => p.width || '80px'};
  height: ${p => p.height || '80px'};
  object-fit: contain;
`;

export const CEmpty = styled(Empty)<{
  width?: string;
  height?: string;
  padding?: string;
  fontSize?: string;
  fontWeight?: string;
}>`
  .ant-empty-image {
    height: ${p => p.height || '100px'} !important;

    > img {
      width: ${p => p.width || '72px'} !important;
      height: ${p => p.height || '100px'} !important;
      object-fit: contain;
    }
  }

  .ant-empty-description {
    color: ${p => p.theme.colors.text.primary} !important;
    padding-top: ${p => p.padding || '0'};
    font-size: ${p => p.fontSize || p.theme.font.size.xxs};
    font-weight: ${p => p.fontWeight || '400'};
    white-space: nowrap;
  }

  .ant-empty-footer {
    display: flex;
    justify-content: center;
  }
`;
